<mat-card class="mat-elevation-z8">
    <form [formGroup]="corporation_zone_register_from">
      <!-- user details -->
      <div class="form-group">
        <label>Corporation Zone Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control code_box" formControlName='corporation_zone_name'>
      </div>
      <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="registerCorporationZone()" [disabled]="!corporation_zone_register_from.valid">{{action}}</button>
    </form>
  </mat-card>
